import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

// The Ending tab's own section. The tab, its head and the other sections
// (the stage's puzzles, in time its history) are other plugins'; this one
// contributes first to `review.ending.sections` and is, for now, an honest
// line about what is not here yet.
const SLOT = 'review.ending.sections';

export function setup(app: PiletApi) {
  const Section: React.FC = () => (
    <div className="phase-section review-ending">
      <h3>Ending</h3>
      <p className="panel-empty">Nothing specific to endings yet: the stage's own analysis arrives with its history plugin.</p>
    </div>
  );
  app.registerExtension(SLOT, Section, { order: 0 });
}
